<template>
	<div class="styleTag">
		<!--弹出框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :close="handleClose">
			<div class="dialogMain">
				<dl>
					<dt><span class="checktip">* </span>尺寸名称：</dt>
					<dd class="cf">
						<div class="fr">							
 							 <el-button type="primary" @click="addInput">添加输入框</el-button>
						</div>
						<div class="sizeTypeInput">
							<div class="" v-for="item,index in dialogData.sizeType">
								<el-input class="small sizeType":value="item"></el-input>
							    <i class="el-icon-circle-close-outline delete" @click="deleteFn(index)"></i>
							</div>
							
						</div>
						
					</dd>
				</dl>				
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()" :loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<!--导航条-->
		<navZcy v-bind:num="'3-8'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main">
			<div class="top cf">
				<div class="topL fl"><span>尺寸类型</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="dataTag">
				<div class="handle">
					<div class="fl">
						<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
						<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
					</div>
					<div class="handleBtn fr">
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table 
						ref="multipleTable"
						:data="tableData" 
						border 
						@selection-change="handleSelectionChange" 
						style="width: 100%;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection" width="200px">
						</el-table-column>
						<el-table-column type="index" label="序号" width="250px">
						</el-table-column>
						<el-table-column prop="sizeType" label="零件尺寸" width="250px">
							<template slot-scope="scope">
								{{scope.row.sizeType.join(' * ')}}
							</template>							
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			loading: false,
			dialogTitle: "", 		//弹出框标题
			dialogVisible: false,	//是否显示弹出框
			dialogData: {},			//弹出框参数
			tableData: [], 			//列表内容
			multipleSelection: []
		}
	},
	methods: {
		refresh() {
			location.reload();
		},
		addInput() {
			this.dialogData.sizeType.push('')
		},
		deleteFn(index) {
			this.dialogData.sizeType.splice(index,1)
		},
		//获取尺寸类型
		getSizeType() {
			let url = "/lightApi/sizeType/inquirySizeTypeById/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handleGet',{'url': url,'Fn': this.getSizeTypeFn,'vue':this})
		},
		getSizeTypeFn(data) {
			console.log(data)
			
			if(data.msg=="ok"){	
				this.tableData = data.data.items
			}else{
				this.tableData = []
			}
		},
		//弹出框关闭
		handleClose: function(done) {
			done();
		},
		//添加系列风格
		handleAdd: function() {
			this.loading =false
			this.dialogTitle = "添加尺寸类型";
			this.dialogData={
				sizeType: []
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)	
		},
		//编辑系列风格
		handleEdit: function(index, row) {
			this.loading =false
			this.dialogTitle = "编辑尺寸类型";
			this.dialogData = {
				id: row.id,
				sizeType: row.sizeType
			};
			this.dialogVisible = true;
			setTimeout(function(){
				$('.input').focus()
			},100)	
		},
		//确定添加/编辑
		handleConfirm: function() {
			this.loading = true
			let data = {
				sizeType: []
			}
			if($('.sizeTypeInput input')){
				for (var i = 0; i < $('.sizeTypeInput input').length; i++) {
					if($('.sizeTypeInput input')[i].value){
						data.sizeType.push($('.sizeTypeInput input')[i].value)
					}					
				}
			}			
			if(data.sizeType.length>0){
				let url = ""
				if(this.dialogTitle == "添加尺寸类型"){
					url = "/lightApi/sizeType/createSizeType/"+sessionStorage.getItem('sessionId')
				}else{
					url = "/lightApi/sizeType/updateSizeType/"+sessionStorage.getItem('sessionId')
					data.id = this.dialogData.id
				}
				console.log(data)
				this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.handleConfirmFn,'vue':this})
			}else{
				this.loading = false
				this.$message({
					type: 'error',
					message: '请输入尺寸类型'
				});
			}
		},
		handleConfirmFn(data) {
			if(data.msg=="ok"){
				this.getSizeType()
				this.dialogVisible = false
			}else{
				this.loading = false		
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
		//复选框选中
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除系列风格
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection					
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该尺寸类型, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/sizeType/deleteSizeType/"+sessionStorage.getItem('sessionId')+"/"+id 
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){	
				this.getSizeType()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		}
	},
	mounted() {
		this.getSizeType()
	},
	components: {
		navZcy
	}
}
</script>

<style scoped>	
	.small{
		width: 100px;
		margin-bottom: 5px;
		margin-right: 5px;
	}
	.delete{
		font-size: 16px;
		cursor: pointer;
	}
	.delete:hover{
		color: crimson;
	}
</style>


// WEBPACK FOOTER //
// src/components/sizeType.vue